import React, { Component } from 'react';
import hakama1 from '../assets/hakama1.png';
import belts1 from '../assets/belts1.png';
import logo2 from '../assets/logo2.png';

class ShopHakamaBelts extends Component {
  render() {
    return (
      <div className="ShopShirts">
        <h1>Thai-Aikikai Shop Hakama</h1>
        <img className="Hakama1" src={hakama1} alt="Hakama1" />
        <h2>Hakama1</h2>
        <br />
        <h1>Thai-Aikikai Shop's Belts</h1>
        <img className="Hakama1" src={belts1} alt="Hakama1" />
        <h2>Belts</h2>
        <div>
          please click to order
        </div>
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default ShopHakamaBelts;
